import { Info } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip'
import React from 'react'

interface FormFieldProps {
    label: string
    helperText?: string
    children: React.ReactNode
}

export const FormField: React.FC<FormFieldProps> = ({ label, helperText, children }) => {
    return (
        <div className="space-y-1">
            <div className="flex items-center gap-1.5">
                <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{label}</label>
                {helperText && (
                    <Tooltip delayDuration={300}>
                        <TooltipTrigger asChild>
                            <div className="p-0.5 -m-0.5 cursor-help">
                                <Info className="h-3.5 w-3.5 text-muted-foreground/50 hover:text-primary transition-colors" />
                            </div>
                        </TooltipTrigger>
                        <TooltipContent side="top" className="max-w-[200px] text-xs px-3 py-1.5 shadow-xl border-primary/10">
                            {helperText}
                        </TooltipContent>
                    </Tooltip>
                )}
            </div>
            {children}
        </div>
    )
}
